import type { ExternalTableSchema } from '@packages/table-builder';

export const jobSchedulerTable: ExternalTableSchema = {
  metadata: {
    title: 'Job Scheduler',
    entity: 'JobScheduler',
    description: 'Scheduled tasks and recurrence management.',
  },

  dataSource: {
    endpoint: '/api/scheduler/api/app/schedule',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      FromCreatedDate: 'filters.fromCreatedDate',
      ToCreatedDate: 'filters.toCreatedDate',
      TaskType: 'filters.taskType',
      TimeZone: 'filters.timeZone',
    },
    filters: [
      {
        name: 'fromCreatedDate',
        placeholder: 'From Created Date',
        type: 'date',
      },
      {
        name: 'toCreatedDate',
        placeholder: 'To Created Date',
        type: 'date',
      },
      {
        name: 'taskType',
        placeholder: 'Task Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/scheduler/api/app/task-type/task-types',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'name', header: 'Name', type: 'text', width: 180, sortable: true },
    {
      field: 'recurrenceStartDateTime',
      header: 'Start Date and Time',
      type: 'date',
      width: 150,
    },
    {
      field: 'nextEventDate',
      header: 'Next Event Date',
      type: 'date',
      width: 150,
      sortable: true,
    },
    {
      field: 'nextEventTime',
      header: 'Next Event Time',
      type: 'text',
      width: 150,
      sortable: true,
    },
    {
      field: 'recurrence',
      header: 'Recurrence',
      type: 'text',
      width: 120,
      sortable: true,
    },
    {
      field: 'taskType',
      header: 'Task Type',
      type: 'text',
      width: 150,
      sortable: true,
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      width: 200,
      align: 'center',
      sortable: true,
      badge: {
        statusMap: { Active: 'success', Disabled: 'error' },
      },
    },
    {
      field: 'createdDate',
      header: 'Created Date',
      type: 'date',
      width: 170,
      sortable: true,
    },
    {
      field: 'createdBy',
      header: 'Created By',
      type: 'text',
      width: 150,
      sortable: true,
    },
    {
      field: 'taskRunBy',
      header: 'Task Run By',
      type: 'text',
      width: 150,
      sortable: true,
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_JOB_SCHEDULER', label: 'View' },
      { id: 'EDIT_JOB_SCHEDULER', label: 'Edit' },
      { id: 'ACTIVATE_JOB_SCHEDULER', label: 'Activate' },
      { id: 'DISABLE_JOB_SCHEDULER', label: 'Disable' },
      { id: 'VIEW_LOGS_JOB_SCHEDULER', label: 'View Logs' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_JOB_SCHEDULER',
        label: 'Add Scheduled Task',
        icon: 'add_circle',
      },
    },
  },

  features: {
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Job Scheduler',
      resizable: true,
      reorderable: true,
    },
  },
};
